export enum AUTH_ENUM {
  AUTHORIZED = 'AUTHORIZED',
  CAN_DELETE_ORDER = 'CAN_DELETE_ORDER',
  CAN_REVERT_ORDER = 'CAN_REVERT_ORDER',
  CAN_VIEW_HQ_MENU = "CAN_VIEW_HQ_CENTRAL_MENU",
  CAN_ISSUE_REFUND = 'CAN_ISSUE_REFUND'
}


